/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Запрос на обновление заявки
 */
export interface OrderUpdate {
  /** Тип аккредитива */
  letterCreditType?: "INTRARUSSIAN" | "INTERNATIONAL";

  /** Способ формирования заявления */
  applicationMethod?: "BY_BANK" | "BY_CLIENT";

  /** Статус исполнения заявки */
  orderStatus?: "NEW" | "PREPARED" | "PARTIALLY_SIGNED" | "SIGNED";
}

/**
 * Ответ после создания или обновления заявки
 */
export interface OrderResponse {
  /**
   * Идентификатор созданной или обновленной заявки
   * @format uuid
   */
  id?: string;

  /**
   * Дата и время создания заявки
   * @format date-time
   */
  created?: string;

  /**
   * Ссылка на клиента, который завёл заявку на аккредитив
   * @format uuid
   */
  clientId?: string;

  /** Тип аккредитива */
  letterCreditType?: string;

  /** Способ формирования заявления */
  applicationMethod?: string;

  /** Статус исполнения заявки */
  orderStatus?: string;

  /**
   * Статус операции
   * @example SUCCESS
   */
  status: string;

  /** Описание ошибки, если операция завершилась неуспешно */
  error?: string;

  /** Данные счета */
  rubAccount?: StatementGetAccount;
}

/**
 * Данные счета
 */
export interface StatementGetAccount {
  /**
   * Идентификатор счета
   * @format uuid
   */
  id?: string;

  /** Номер счёта */
  accountNumber?: string;

  /** Трёхбуквенный алфавитный код валюты */
  currency?: string;

  /** Баланс */
  balance?: number;

  /** Назначение */
  purpose?: string;

  /** Тип счета */
  type?: string;

  /**
   * Дата открытия
   * @format date
   */
  openDate?: string;

  /**
   * Дата закрытия
   * @format date
   */
  closeDate?: string;

  /** Наличие контракта на балансовый продукт на счете */
  balanceContract?: boolean;
}

/**
 * Ошибка на стороне сервиса
 */
export interface GenericError {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Информация о клиенте
 */
export interface OrderClientInfo {
  /** Почта клиента */
  clientMail?: string;

  /** ФИО клиента */
  clientName?: string;

  /** Телефон клиента */
  clientPhoneNumber?: string;

  /** КПП клиента */
  clientKpp?: string;

  /** Счет клиента */
  clientAccount?: string;

  /** Наименование клиента */
  clientFullName?: string;

  /** ИНН клиента */
  clientInn?: string;

  /** Адрес клиента */
  clientAddress?: string;
}

/**
 * Запрос на создание заявки
 */
export interface OrderRequest {
  /** Тип аккредитива */
  letterCreditType: "INTRARUSSIAN" | "INTERNATIONAL";

  /** Способ формирования заявления */
  applicationMethod: "BY_BANK" | "BY_CLIENT";

  /** Идентификаторы файла договора */
  fileIds?: string[];

  /** Информация о клиенте */
  orderClientInfo?: OrderClientInfo;

  /** Рублевый счет для возврата покрытия */
  rubAcc?: string;
}

export interface AttachmentUploadResponse {
  /** @format uuid */
  contractId?: string;
  fileName?: string;
  error?: string;
}

/**
 * Список документов для исполнения аккредитива
 */
export interface ExecutingIntrarussianDocument {
  /** @format uuid */
  id?: string;
  documentName?: string;

  /** @format int32 */
  originalCount?: number;

  /** @format int32 */
  copyCount?: number;
  contentRequirements?: string;

  /** Редактируемый текст описания */
  description?: string;

  /** Тип документа */
  documentType?: string;

  /**
   * Порядковый номер
   * @format int32
   */
  number?: number;
}

/**
 * Дополнительные условия
 */
export interface OtherCondition {
  /** @format uuid */
  id?: string;
  description?: string;

  /** @format int32 */
  number?: number;
}

/**
 * Дополнительные инструкции
 */
export interface OtherInstruction {
  /** @format uuid */
  id?: string;
  description?: string;
}

/**
 * Разрешение на документ
 */
export interface PermissionResponse {
  /** Название действия */
  name?: string;

  /** Описание действия */
  description?: string;

  /** Признак доступности действия */
  isAvailable?: boolean;
}

/**
 * Внутрироссийское заявление на аккредитив
 */
export interface StatementRussianUpdate {
  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Вид клиента получателя */
  receiverType?: string;

  /** Статус получателя */
  receiverStatus?: string;

  /**
   * Идентификатор получателя из справочника
   * @format uuid
   */
  receiverId?: string;

  /** Наименование получателя */
  receiverName?: string;

  /** Адрес регистрации получателя */
  receiverRegistrationAddress?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /** КПП получателя */
  receiverKpp?: string;

  /**
   * Дата рождения получателя
   * @format date
   */
  receiverBirthDate?: string;

  /** Место рождения получателя */
  receiverBirthPlace?: string;

  /** Реквизиты документа получателя */
  receiverDocument?: string;

  /** Адрес фактического проживания получателя */
  receiverFactAddress?: string;

  /** Наименование банка получателя */
  receiverBankName?: string;

  /** Адрес банка получателя */
  receiverBankAddress?: string;

  /** БИК банка получателя */
  receiverBankBik?: string;

  /** Корр. счет банка получателя */
  receiverBankCor?: string;

  /** Вид аккредитива. Признак отзывности */
  isLetterCreditRevokable?: boolean;

  /** Вид аккредитива. Признак покрытости */
  isLetterCreditCover?: boolean;

  /**
   * Дата окончания действия аккредитива
   * @format date
   */
  untilDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /** Сумма аккредитива прописью */
  amountFormulation?: string;

  /** Признак включения НДС в сумму */
  isNds?: boolean;

  /** Значение НДС */
  valueNds?: number;

  /** Исполняющий банк. Переключатель выбора */
  executingBankType?: string;

  /** Наименование исполняющего банка (если иной банк) */
  executingBankName?: string;

  /** Адрес исполняющего банка (если иной банк) */
  executingBankAddress?: string;

  /** БИК исполняющего банка (если иной банк) */
  executingBankBik?: string;

  /** Корр. счет исполняющего банка (если иной банк) */
  executingBankCor?: string;

  /** Способ исполнения аккредитива */
  executionMethodType?: string;

  /**
   * Длительность отсрочки в календарных днях
   * @format int32
   */
  executionMethodDuration?: number;

  /** С какого момента начинается отсрочка */
  executionMethodEvent?: string;

  /** Описание способа исполнения аккредитива */
  executionMethodDescription?: string;

  /** Требуется подтверждение аккредитива исполняющим банком */
  isExecutionBankApproveNeeded?: boolean;

  /** Признак разрешения частичных выплат */
  isPartialPaymentAllowed?: boolean;

  /** Признак разрешения частичных отгрузок/выполнения работ/оказания услуг */
  isPartialShipmentAllowed?: boolean;

  /** Признак разрешения перегрузок */
  isTranshipmentAllowed?: boolean;

  /** Отгрузка/отправка из */
  receiptPlace?: string;

  /** Место назначения */
  deliveryPlace?: string;

  /**
   * Срок отгрузки товаров/выполнения работ/оказания услуг
   * @format date
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки товаров/выполнения работ/ оказания услуг, с
   * @format date
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки товаров/выполнения работ/ оказания услуг, по
   * @format date
   */
  shippingPeriodEnd?: string;

  /** Грузоотправитель */
  loadingPort?: string;

  /** Грузополучатель */
  unloadingPort?: string;

  /** Назначение платежа, краткое описание */
  paymentDescription?: string;

  /** Назначение платежа, наименование договора */
  paymentContractName?: string;

  /** Назначение платежа, номер договора */
  paymentContractNumber?: string;

  /**
   * Назначение платежа, дата договора
   * @format date
   */
  paymentContractDate?: string;

  /** Назначение платежа, плательщик в договоре */
  paymentContractPayer?: string;

  /** Назначение платежа, получатель в договоре */
  paymentContractReceiver?: string;

  /** Срок предоставления документов, способ отчёта */
  documentProvisionMethod?: string;

  /**
   * Срок предоставления документов, установленный срок в календарных днях
   * @format int32
   */
  documentProvisionDays?: number;

  /** Срок предоставления документов, описание события */
  documentProvisionEvent?: string;

  /** Признак допустимости указания инициалов вместо имён и отчеств в документах */
  isInitialsAllowed?: boolean;

  /** Признак допустимости указания аббревиатур вместо полных наименований организационно-правовых форм */
  isAbbreviationAllowed?: boolean;

  /** Порядок оплаты комиссий и расходов */
  expensesMethod?: string;

  /** Комиссии и расходы банка-эмитента */
  expensesEmitentBank?: string;

  /** Комиссии и расходы Исполняющего банка */
  expensesExecutionBank?: string;

  /** Комиссия за подтверждение аккредитива */
  expensesLcApprove?: string;

  /** Все комиссии и расходы по аккредитиву (всех банков) */
  expensesAll?: string;

  /** Порядок комиссий */
  expensesDescription?: string;

  /** Списать средства в сумме аккредитива со счета в АО "Россельхозбанк" для перечисления на счет покрытия по аккредитиву */
  isWriteOffFromAccount?: boolean;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по документу */
  isCoverFormsFromCredit?: boolean;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** Номер договора покрытия */
  coverDocumentNum?: string;

  /**
   * Дата договора покрытия
   * @format date
   */
  coverDocumentDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива */
  isApplicationContractPart?: boolean;

  /** Номер договора */
  partContractNum?: string;

  /**
   * Дата договора
   * @format date
   */
  partContractDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения об открытии непокрытых аккредитивов */
  isGeneralNegotiation?: boolean;

  /** Номер Генерального соглашения */
  negotiationNumber?: string;

  /**
   * Дата Генерального соглашения
   * @format date
   */
  negotiationDate?: string;

  /** Установить срок возмещения Плательщиком суммы платежа по аккредитиву, выполненного АО "Россельхозбанк" за счёт собственных средств */
  isSetRefundPeriod?: boolean;

  /**
   * Срок возмещения, календарные дни
   * @format int32
   */
  refundPeriod?: number;

  /** Признак автоматического списания комиссий и расходов */
  isAutoWriteOffAllowed?: boolean;

  /** Контактный телефон */
  contactPhone?: string;

  /** Контактный Email */
  contactEmail?: string;

  /** Признак, что клиент ознакомлен и согласен с положениями на заведение аккредитива */
  isClientApproves?: boolean;

  /** Счёт получателя */
  receiverAccountNumber?: string;

  /** Список документов для исполнения аккредитива */
  executingDocuments?: ExecutingIntrarussianDocument[];

  /** Иные дополнительные условия */
  otherConditions?: OtherCondition[];

  /** Комиссии и расходы банка, обслуживающего счёт Получателя */
  expensesReceiverBank?: string;

  /** Иная инструкция и распоряжение */
  otherInstructions?: OtherInstruction[];

  /**
   * Идентификатор заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст о свободном описаниии изменений */
  changeDescription?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор заявки
   * @format uuid
   */
  orderId?: string;

  /**
   * Идентификатор счета плательщика
   * @format uuid
   */
  payerAccountId?: string;

  /**
   * Идентификатор счёта для списания средств
   * @format uuid
   */
  writeOffAccountId?: string;

  /**
   * Идентификатор счёта для списания
   * @format uuid
   */
  autoWriteOffAccountId?: string;

  /** Полномочия */
  permissions?: PermissionResponse[];

  /**
   * Исполняющий банк
   * @format uuid
   */
  executingBankId?: string;

  /** Тип НДС */
  typeNds?: "PERCENTAGE" | "MONEY";

  /**
   * Филиал исполняющего банка
   * @format uuid
   */
  executingBankBranchId?: string;

  /** Гражданство получателя. Только для Индивидуальный предприниматель или Физическое лицо */
  receiverCitizenship?: string;

  /** Пол получателя.Только для Индивидуальный предприниматель или Физическое лицо */
  receiverGender?: string;

  /** Эл.почта получателя. Только для Индивидуальный предприниматель или Физическое лицо */
  receiverEmail?: string;

  /** Филиал исполняющего банка */
  executingFilialName?: string;

  /** Идентификаторы файлов вложения */
  attachments?: string[];
}

export interface UpdateIntrarussianRequest {
  /** @format uuid */
  orderId?: string;

  /** Внутрироссийское заявление на аккредитив */
  applicationData?: StatementRussianUpdate;
}

/**
 * Ошибки входных данных
 */
export interface ValidationError {
  /** Список ошибок */
  errors?: ValidationItem[];

  /** Список предупреждений */
  warnings?: ValidationItem[];
}

/**
 * Список предупреждений
 */
export interface ValidationItem {
  fields?: string[];
  message?: string;
}

/**
 * Информация о вложении
 */
export interface AttachmentInfo {
  /**
   * Индетификатор вложений
   * @format uuid
   */
  attachmentId?: string;

  /** Имя файла */
  fileName?: string;

  /**
   * Размер файла
   * @format int64
   */
  fileSize?: number;

  /** Признак готовности файла к скачиванию */
  isReady?: boolean;

  /** Код ошибки */
  errorCode?: string;

  /** Описание ошибки */
  errorDescription?: string;
}

/**
 * Филиал банка
 */
export interface Branch {
  /**
   * Id филиала
   * @format uuid
   */
  id?: string;

  /** Краткое название филиала */
  shortName?: string;

  /** Название филиала */
  branchName?: string;

  /** Код филиала */
  branchCode?: string;

  /** Бик филиала */
  bic?: string;
}

export interface IntrarussianResponse {
  status?: string;

  /** @format uuid */
  applicationId?: string;

  /** @format int32 */
  errorCode?: number;
  errorText?: string;

  /** Наличие подписантов */
  signData?: SignData;

  /** Внутрироссийское заявление на аккредитив */
  applicationData?: StatementRussian;
  orderStatus?: string;
  letterCreditId?: string;

  /** Информация о клиенте */
  orderClientInfo?: OrderClientInfo;
}

/**
 * Наличие подписантов
 */
export interface SignData {
  isFirstSignExists?: boolean;
  isSecondSignExists?: boolean;
}

/**
 * Внутрироссийское заявление на аккредитив
 */
export interface StatementRussian {
  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Вид клиента получателя */
  receiverType?: string;

  /** Статус получателя */
  receiverStatus?: string;

  /**
   * Идентификатор получателя из справочника
   * @format uuid
   */
  receiverId?: string;

  /** Наименование получателя */
  receiverName?: string;

  /** Адрес регистрации получателя */
  receiverRegistrationAddress?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /** КПП получателя */
  receiverKpp?: string;

  /**
   * Дата рождения получателя
   * @format date
   */
  receiverBirthDate?: string;

  /** Место рождения получателя */
  receiverBirthPlace?: string;

  /** Реквизиты документа получателя */
  receiverDocument?: string;

  /** Адрес фактического проживания получателя */
  receiverFactAddress?: string;

  /** Наименование банка получателя */
  receiverBankName?: string;

  /** Адрес банка получателя */
  receiverBankAddress?: string;

  /** БИК банка получателя */
  receiverBankBik?: string;

  /** Корр. счет банка получателя */
  receiverBankCor?: string;

  /** Вид аккредитива. Признак отзывности */
  isLetterCreditRevokable?: boolean;

  /** Вид аккредитива. Признак покрытости */
  isLetterCreditCover?: boolean;

  /**
   * Дата окончания действия аккредитива
   * @format date
   */
  untilDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /** Сумма аккредитива прописью */
  amountFormulation?: string;

  /** Признак включения НДС в сумму */
  isNds?: boolean;

  /** Значение НДС */
  valueNds?: number;

  /** Исполняющий банк. Переключатель выбора */
  executingBankType?: string;

  /** Наименование исполняющего банка (если иной банк) */
  executingBankName?: string;

  /** Адрес исполняющего банка (если иной банк) */
  executingBankAddress?: string;

  /** БИК исполняющего банка (если иной банк) */
  executingBankBik?: string;

  /** Корр. счет исполняющего банка (если иной банк) */
  executingBankCor?: string;

  /** Способ исполнения аккредитива */
  executionMethodType?: string;

  /**
   * Длительность отсрочки в календарных днях
   * @format int32
   */
  executionMethodDuration?: number;

  /** С какого момента начинается отсрочка */
  executionMethodEvent?: string;

  /** Описание способа исполнения аккредитива */
  executionMethodDescription?: string;

  /** Требуется подтверждение аккредитива исполняющим банком */
  isExecutionBankApproveNeeded?: boolean;

  /** Признак разрешения частичных выплат */
  isPartialPaymentAllowed?: boolean;

  /** Признак разрешения частичных отгрузок/выполнения работ/оказания услуг */
  isPartialShipmentAllowed?: boolean;

  /** Признак разрешения перегрузок */
  isTranshipmentAllowed?: boolean;

  /** Отгрузка/отправка из */
  receiptPlace?: string;

  /** Место назначения */
  deliveryPlace?: string;

  /**
   * Срок отгрузки товаров/выполнения работ/оказания услуг
   * @format date
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки товаров/выполнения работ/ оказания услуг, с
   * @format date
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки товаров/выполнения работ/ оказания услуг, по
   * @format date
   */
  shippingPeriodEnd?: string;

  /** Грузоотправитель */
  loadingPort?: string;

  /** Грузополучатель */
  unloadingPort?: string;

  /** Назначение платежа, краткое описание */
  paymentDescription?: string;

  /** Назначение платежа, наименование договора */
  paymentContractName?: string;

  /** Назначение платежа, номер договора */
  paymentContractNumber?: string;

  /**
   * Назначение платежа, дата договора
   * @format date
   */
  paymentContractDate?: string;

  /** Назначение платежа, плательщик в договоре */
  paymentContractPayer?: string;

  /** Назначение платежа, получатель в договоре */
  paymentContractReceiver?: string;

  /** Срок предоставления документов, способ отчёта */
  documentProvisionMethod?: string;

  /**
   * Срок предоставления документов, установленный срок в календарных днях
   * @format int32
   */
  documentProvisionDays?: number;

  /** Срок предоставления документов, описание события */
  documentProvisionEvent?: string;

  /** Признак допустимости указания инициалов вместо имён и отчеств в документах */
  isInitialsAllowed?: boolean;

  /** Признак допустимости указания аббревиатур вместо полных наименований организационно-правовых форм */
  isAbbreviationAllowed?: boolean;

  /** Порядок оплаты комиссий и расходов */
  expensesMethod?: string;

  /** Комиссии и расходы банка-эмитента */
  expensesEmitentBank?: string;

  /** Комиссии и расходы Исполняющего банка */
  expensesExecutionBank?: string;

  /** Комиссия за подтверждение аккредитива */
  expensesLcApprove?: string;

  /** Все комиссии и расходы по аккредитиву (всех банков) */
  expensesAll?: string;

  /** Порядок комиссий */
  expensesDescription?: string;

  /** Списать средства в сумме аккредитива со счета в АО "Россельхозбанк" для перечисления на счет покрытия по аккредитиву */
  isWriteOffFromAccount?: boolean;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по документу */
  isCoverFormsFromCredit?: boolean;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** Номер договора покрытия */
  coverDocumentNum?: string;

  /**
   * Дата договора покрытия
   * @format date
   */
  coverDocumentDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива */
  isApplicationContractPart?: boolean;

  /** Номер договора */
  partContractNum?: string;

  /**
   * Дата договора
   * @format date
   */
  partContractDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения об открытии непокрытых аккредитивов */
  isGeneralNegotiation?: boolean;

  /** Номер Генерального соглашения */
  negotiationNumber?: string;

  /**
   * Дата Генерального соглашения
   * @format date
   */
  negotiationDate?: string;

  /** Установить срок возмещения Плательщиком суммы платежа по аккредитиву, выполненного АО "Россельхозбанк" за счёт собственных средств */
  isSetRefundPeriod?: boolean;

  /**
   * Срок возмещения, календарные дни
   * @format int32
   */
  refundPeriod?: number;

  /** Признак автоматического списания комиссий и расходов */
  isAutoWriteOffAllowed?: boolean;

  /** Контактный телефон */
  contactPhone?: string;

  /** Контактный Email */
  contactEmail?: string;

  /** Признак, что клиент ознакомлен и согласен с положениями на заведение аккредитива */
  isClientApproves?: boolean;

  /** Счёт получателя */
  receiverAccountNumber?: string;

  /** Список документов для исполнения аккредитива */
  executingDocuments?: ExecutingIntrarussianDocument[];

  /** Иные дополнительные условия */
  otherConditions?: OtherCondition[];

  /** Комиссии и расходы банка, обслуживающего счёт Получателя */
  expensesReceiverBank?: string;

  /** Иная инструкция и распоряжение */
  otherInstructions?: OtherInstruction[];

  /**
   * Идентификатор заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст о свободном описаниии изменений */
  changeDescription?: string;

  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор заявки
   * @format uuid
   */
  orderId?: string;

  /** Данные счета */
  payerAccount?: StatementGetAccount;

  /** Данные счета */
  writeOffAccount?: StatementGetAccount;

  /** Данные счета */
  autoWriteOffAccount?: StatementGetAccount;

  /** Полномочия */
  permissions?: PermissionResponse[];

  /** Тип НДС */
  typeNds?: string;

  /** Филиал банка */
  executingBankBranch?: Branch;

  /** Гражданство получателя. Только для Индивидуальный предприниматель или Физическое лицо */
  receiverCitizenship?: string;

  /** Пол получателя.Только для Индивидуальный предприниматель или Физическое лицо */
  receiverGender?: string;

  /** Эл.почта получателя. Только для Индивидуальный предприниматель или Физическое лицо */
  receiverEmail?: string;

  /** Филиал исполняющего банка */
  executingFilialName?: string;

  /** Причина отказа */
  rejectReason?: string;

  /** Информация о вложении */
  attachments?: AttachmentInfo[];
}

/**
 * Документ для исполнения международного аккредитива
 */
export interface ExecutingInternationalDocument {
  /**
   * Идентификатор документа
   * @format uuid
   */
  id?: string;

  /** Тип документа */
  documentType?: string;

  /** Наименование иного документа */
  documentName?: string;

  /** Редактируемый текст описания */
  description?: string;

  /**
   * Порядковый номер
   * @format int32
   */
  number?: number;
}

/**
 * Внероссийское заявление на аккредитив
 */
export interface StatementInternational {
  /**
   * Идентификатор документа
   * @format uuid
   * @example b3c5e2d4-1d2f-4c3a-8e5f-6a7b8c9d0e1f
   */
  id?: string;

  /**
   * Идентификатор клиента, который желает завести аккредитив
   * @format uuid
   * @example c1d2e3f4-a5b6-c7d8-e9f0-a1b2c3d4e5f6
   */
  clientId?: string;

  /**
   * Идентификатор заявки, в рамках которой создано заявление
   * @format uuid
   * @example 22222222-2222-2222-2222-222222222222
   */
  orderId?: string;

  /**
   * Аккредитив Покрытый/Непокрытый
   * @example true
   */
  isAccreditivCover?: boolean;

  /**
   * Источник финансирования
   * @example Источник финансирования
   */
  financingSource?: string;

  /**
   * Банк-эмитент
   * @example b1c2d3e4-f5a6-7b8c-9d0e-f1a2b3c4d5e6
   */
  issuerBankId?: string;

  /**
   * Дата истечения срока действия аккредитива
   * @format date
   * @example 2024-12-31
   */
  untilDate?: string;

  /**
   * Место истечения срока действия аккредитива
   * @example г. Санкт-Петербург
   */
  untilPlace?: string;

  /**
   * Толеранс (поле 39A Допуск суммы аккредитива): процент увеличения
   * @example 3
   */
  tolerancePercentIncrease?: number;

  /**
   * Толеранс (поле 39A Допуск суммы аккредитива): процент уменьшения
   * @example 2
   */
  tolerancePercentDecrease?: number;

  /**
   * Инструкции по подтверждению
   * @example Инструкция по подтверждению аккредитива
   */
  confirmationInstruction?: string;

  /**
   * Подтверждающий банк
   * @example BANK-789
   */
  confirmationBankId?: string;

  /**
   * Признак выбора подтверждающего банка на усмотрение РСХБ
   * @example true
   */
  isConfirmBankByRshb?: boolean;

  /**
   * Исполняющий банк
   * @example Банк исполнения
   */
  executionBank?: string;

  /**
   * Идентификатор исполняющего банка
   * @example BANK-456
   */
  executionBankId?: string;

  /**
   * Способ исполнения
   * @example Путь исполнения
   */
  executionPath?: string;

  /**
   * Детали отсрочки платежа
   * @example Детали отсроченного платежа
   */
  deferredPaymentDetails?: string;

  /**
   * Частичные отгрузки разрешены
   * @example true
   */
  isPartialShipmentAllowed?: boolean;

  /**
   * Перегрузка разрешена
   * @example false
   */
  isTranshipmentAllowed?: boolean;

  /**
   * Место принятия к перевозке
   * @example г. Екатеринбург
   */
  receiptPlace?: string;

  /**
   * Место конечного назначения
   * @example г. Казань
   */
  deliveryPlace?: string;

  /**
   * Последняя дата отгрузки
   * @format date
   * @example 2024-11-30
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки с
   * @format date
   * @example 2024-05-01
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки по
   * @format date
   * @example 2024-10-31
   */
  shippingPeriodEnd?: string;

  /**
   * Порт погрузки
   * @example Порт погрузки
   */
  loadingPort?: string;

  /**
   * Порт выгрузки
   * @example Порт выгрузки
   */
  unloadingPort?: string;

  /**
   * Описание товара
   * @example Описание товара
   */
  goodDescription?: string;

  /**
   * Условия поставки
   * @example Условия поставки
   */
  shippingDetails?: string;

  /**
   * Требуемые документы
   * @example Требуемые документы
   */
  documentNeed?: string;

  /**
   * Срок предоставления документов
   * @example Период предоставления документов
   */
  documentProvisionPeriod?: string;

  /**
   * Способ предоставления документов
   * @example Способ предоставления документов
   */
  documentProvisionMethod?: string;

  /**
   * Дополнительные условия
   * @example Дополнительные условия
   */
  additionalConditions?: string;

  /**
   * Комиссии и расходы
   * @example Комиссии и расходы
   */
  commissionExpenses?: string;

  /**
   * Частичные выплаты
   * @example Частичные выплаты
   */
  partialPayments?: string;

  /**
   * Вид коммерческого договора
   * @example Тип контракта
   */
  contractType?: string;

  /**
   * Номер контракта
   * @example CON-2024-0001
   */
  contractNumber?: string;

  /**
   * Дата контракта
   * @format date
   * @example 2024-01-15
   */
  contractDate?: string;

  /**
   * Дополнительная информация
   * @example Дополнительная информация
   */
  additionalInformation?: string;

  /**
   * Трассат
   * @example false
   */
  drafted?: string;

  /**
   * Условие тратт
   * @example Условие тратт
   */
  draftCondition?: string;

  /**
   * Покрытие в сумме аккредитива просим списать со счета Приказодателя
   * @example true
   */
  isWriteOffFromAccount?: boolean;

  /**
   * Идентификатор счета списания
   * @format uuid
   * @example e1f2a3b4-c5d6-e7f8-a9b0-c1d2e3f4a5b6
   */
  writeOffAccountId?: string;

  /**
   * Покрытие просим сформировать за счет кредитных средств Банка
   * @example false
   */
  isCoverFormsFromCredit?: boolean;

  /**
   * Тип документа
   * @example Тип документа 1
   */
  coverDocumentType?: string;

  /**
   * Номер договора
   * @example DOC-2024-0001
   */
  coverDocumentNum?: string;

  /**
   * Дата договора
   * @format date
   * @example 2024-02-20
   */
  coverDocumentDate?: string;

  /**
   * Настоящее заявление является неотъемлемой частью Договора
   * @example true
   */
  isApplicationContractPart?: boolean;

  /**
   * Номер договора
   * @example PART-CON-2024-0001
   */
  partContractNum?: string;

  /**
   * Дата договора
   * @format date
   * @example 2024-03-10
   */
  partContractDate?: string;

  /**
   * Настоящее заявление является неотъемлемой частью Генерального соглашения
   * @example false
   */
  isGeneralNegotiation?: boolean;

  /**
   * Номер Генерального соглашения
   * @example NEG-2024-0001
   */
  negotiationNumber?: string;

  /**
   * Дата Генерального соглашения
   * @format date
   * @example 2024-04-05
   */
  negotiationDate?: string;

  /**
   * Установить срок возмещения
   * @example true
   */
  isSetRefundPeriod?: boolean;

  /**
   * Срок возмещения
   * @format int32
   * @example 30
   */
  refundPeriod?: number;

  /**
   * Порядок оплаты комиссий и расходов
   * @example Порядок оплаты комиссий
   */
  expensesMethod?: string;

  /**
   * Комиссии и расходы банка-эмитента
   * @example Комиссии банка-эмитента
   */
  expensesEmitentBank?: string;

  /**
   * Комиссии и расходы вне территории РФ
   * @example Комиссии вне РФ
   */
  expensesForeign?: string;

  /**
   * Все комиссии и расходы
   * @example Все комиссии
   */
  expensesAll?: string;

  /**
   * Описание иного порядка расходов
   * @example Описание порядка расходов
   */
  expensesDescription?: string;

  /**
   * Идентификатор счета для списания комиссий и расходов
   * @format uuid
   * @example d1e2f3a4-b5c6-d7e8-f9a0-b1c2d3e4f5a6
   */
  expensesAccountId?: string;

  /**
   * Тип допуска
   * @example Тип допуска
   */
  toleranceType?: string;

  /**
   * Величина допуска
   * @example 5
   */
  toleranceAmount?: number;

  /**
   * Денежная сумма
   * @example 1000000
   */
  amountValue?: number;

  /**
   * Валюта денежной суммы
   * @example USD
   */
  amountCurrency?: string;

  /**
   * Сумма аккредитива прописью
   * @example Один миллион долларов США
   */
  amountFormulation?: string;

  /**
   * Номер заявления
   * @example INT-2024-0001
   */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /**
   * Ид Бенефициара из справочника
   * @format uuid
   * @example f1a2b3c4-d5e6-f7a8-b9c0-d1e2f3a4b5c6
   */
  beneficiaryId?: string;

  /**
   * Наименование Бенефициара
   * @example ООО Бенефициар
   */
  beneficiaryName?: string;

  /**
   * Адрес Бенефициара
   * @example г. Москва, ул. Примерная, д.1
   */
  beneficiaryAddress?: string;

  /**
   * Номер счёта Бенефициара
   * @example 1234567890
   */
  beneficiaryAccountNum?: string;

  /**
   * Идентификатор авизующего банка
   * @example BANK-123
   */
  advisingBankId?: string;

  /**
   * Вид аккредитива
   * @example Тип аккредитива
   */
  letterCreditKind?: string;

  /**
   * ФИО контактного лица Приказодателя
   * @example Иван Иванов
   */
  contactName?: string;

  /**
   * Телефон контактного лица Приказодателя
   * @example +7 999 123-45-67
   */
  contactPhone?: string;

  /**
   * Email контактного лица Приказодателя
   * @example ivan.ivanov@example.com
   */
  contactEmail?: string;

  /** Требуемые документы */
  requiredDocuments?: string;

  /**
   * Требуемые документы (оригиналы)
   * @format int32
   */
  requiredDocumentsOrig?: number;

  /**
   * Требуемые документы (копии)
   * @format int32
   */
  requiredDocumentsCopy?: number;

  /**
   * Признак, что клиент ознакомлен и согласен с положениями на заведение аккредитива
   * @example true
   */
  isClientApproves?: boolean;

  /** Список исполненных документов */
  executingDocuments?: ExecutingInternationalDocument[];

  /**
   * Признак указания данных тратты Бенефициара
   * @example false
   */
  isDraft?: boolean;

  /**
   * Срок тратты
   * @example 2024-06-30
   */
  draftUntil?: string;

  /**
   * Идентификатор банка тратты
   * @example BANK-321
   */
  draftBankId?: string;

  /**
   * id заявления изменяемого аккредитива
   * @format uuid
   * @example a5b6c7d8-e9f0-a1b2-c3d4-e5f6a7b8c9d0
   */
  previousOrderId?: string;

  /**
   * Свободное описание изменений
   * @example Описание изменений
   */
  changeDescription?: string;

  /** КПП платильщика */
  payerKpp?: string;

  /**
   * Id получателя
   * @format uuid
   */
  receiverId?: string;

  /** Вид клиента получателя */
  receiverType?: string;

  /** Организационно-правовая форма/Правовой статус/Вид деятельности получателя */
  receiverStatus?: string;

  /** Полное или сокращённое наименование/ФИО получателя */
  receiverName?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /**
   * Дата рождения получателя
   * @format date
   */
  receiverBirthDate?: string;

  /** Место рождения получателя */
  receiverBirthPlace?: string;

  /** Реквизиты документа, удостоверяющего личность получателя */
  receiverDocument?: string;

  /** Адрес/Адрес регистрации получателя */
  receiverRegistrationAddress?: string;

  /** Адрес фактического проживания получателя */
  receiverFactAddress?: string;

  /** Номер счёта получателя */
  receiverAccountNumber?: string;

  /** УНК */
  unk?: string;

  /**
   * Филиал, где договор поставлен на учет
   * @format uuid
   */
  contractRegisteredBranchId?: string;

  /** Тип валютного контроля */
  contractRegisteredType?:
    | "BRANCH_BANK"
    | "ANOTHER_BANK"
    | "NOT_SUBJECT_FOR_REGISTER";

  /** Договор поставлен на учет. Наименование иного уполномоченного банка */
  contractRegisteredAnotherBank?: string;

  /**
   * Дополнительные условия
   * @example Дополнительное условие 1
   */
  otherConditions?: OtherCondition[];

  /**
   * Дополнительные инструкции
   * @example Дополнительная инструкция 1
   */
  otherInstructions?: OtherInstruction[];

  /** Идентификаторы файлов вложения */
  attachments?: string[];

  /**
   * Период отгрузки (поле 44D, до 65 символов)
   * @example 01.05.2024 - 31.10.2024
   */
  shippingPeriod?: string;

  /**
   * Дата УНК
   * @format date
   */
  unkDate?: string;

  /** Рублевый счет для возврата покрытия */
  rubAcc?: string;

  /**
   * Невозможность завершения расчетов по аккредитиву в связи с возникновением  ограничений
   * @example true
   */
  isInabilityCompleteCalc?: boolean;

  /**
   * Приказодатель проинформирован
   * @example true
   */
  isApplicantInformed?: boolean;
}

/**
 * Запрос на создание или обновление заявления на международный аккредитив
 */
export interface UpdateInternationalRequest {
  /**
   * Идентификатор заявки, в рамках которой создаётся или редактируется заявление
   * @format uuid
   */
  orderId: string;

  /** Внероссийское заявление на аккредитив */
  applicationData: StatementInternational;
}

/**
 * Ответ на запрос создания или получения заявления на международный аккредитив
 */
export interface InternationalResponse {
  /** Статус выполнения запроса */
  status: string;

  /**
   * Идентификатор созданного или отредактированного заявления
   * @format uuid
   */
  applicationId?: string;

  /**
   * Код ошибки
   * @format int32
   */
  errorCode?: number;

  /** Сообщение об ошибке */
  errorText?: string;

  /** Наличие подписантов */
  signData?: SignData;

  /** Внероссийское заявление на аккредитив */
  applicationData?: StatementInternational;
}

/**
 * Внутрироссийское заявление изменения аккредитива
 */
export interface StatementRussianChangeUpdate {
  /**
   * Id записи
   * @format uuid
   */
  id?: string;

  /** Идентификатор аккредитива */
  accId?: string;

  /** Номер аккредитива */
  accNumber?: string;

  /**
   * Дата аккредитива
   * @format date
   */
  accDate?: string;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /**
   * Плательщик - это Клиент
   * @format uuid
   */
  clientId?: string;

  /** Получатель */
  receiverName?: string;

  /** комиссии и расходы АО «Россельхозбанк» - за счет получателя */
  isCommisionsReceiver?: boolean;

  /** Комиссии и расходы исполняющего банка */
  executuingBankCommission?: string;

  /** Комиссии и расходы банка получателя */
  receiverCommisions?: string;

  /** Иные условия оплаты комиссий и расходов */
  otherCommissionConditions?: string;

  /** При увеличении суммы покрытого аккредитива: списать средства */
  isCoverIncreaseWriteOff?: boolean;

  /** При увеличении суммы покрытого аккредитива: списать средства в сумме увеличения аккредитива */
  coverIncreaseWriteOff?: number;

  /**
   * При увеличении суммы покрытого аккредитива: списать средства со счета № в АО «Россельхозбанк»
   * @format uuid
   */
  coverIncreaseWriteOffAccountId?: string;

  /**
   * При увеличении суммы покрытого аккредитива: списать средства, филиал
   * @format uuid
   */
  coverIncreaseWriteOffBranchId?: string;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по кредитному договору/договору об открытии кредитной линии */
  isCoverFromCredit?: boolean;

  /** № кредитного договора/договора об открытии кредитной линии */
  coverFromCreditNum?: string;

  /**
   * Дата кредитного договора/договора об открытии кредитной линии
   * @format date
   */
  coverFromCreditDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива? */
  isApplicationPartNonCovered?: boolean;

  /** № договора об открытии непокрытого аккредитива */
  applicationPartNonCoveredNum?: string;

  /**
   * Дата договора об открытии непокрытого аккредитива
   * @format date
   */
  applicationPartNonCoveredDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения об открытии непокрытых аккредитивов? */
  isApplicationPartGeneral?: boolean;

  /** № генерального соглашения */
  applicationPartGeneralNum?: string;

  /**
   * Дата генерального соглашения
   * @format date
   */
  applicationPartGeneralDate?: string;

  /**
   * Списывать без дополнительных распоряжений Плательщика комиссии и расходы в соответствии с действующими тарифами АО «Россельхозбанк», возмещение предъявленных АО «Россельхозбанк» расходов и комиссий банков-контрагентов по аккредитиву, суммы банковских комиссий и расходов, не оплаченных Получателем, со счета №
   * @format uuid
   */
  defaultWriteOffAccountId?: string;

  /**
   * Филиал для списания без дополнительных распоряжений Плательщика
   * @format uuid
   */
  defaultWriteOffAccountBranchId?: string;

  /**
   * Id заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст со свободным описанием изменений */
  changeDescription?: string;

  /** ИНН приказодателя */
  ordererInn?: string;

  /** КПП приказодателя */
  ordererKpp?: string;

  /** Почта приказодателя */
  ordererEmail?: string;

  /** Телефон приказодателя */
  ordererPhone?: string;

  /**
   * Id филиала банка приказодателя
   * @format uuid
   */
  ordererBranchCodeId?: string;

  /** Идентификаторы файлов вложения */
  attachments?: string[];

  /** Установлен срок возмещения */
  isSetRefundPeriod?: boolean;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** Порядок оплаты комиссий и расходов */
  expensesMethod?: string;

  /** Комиссии и расходы банка-эмитента */
  expensesEmitentBank?: string;

  /** Комиссии и расходы Исполняющего банка */
  expensesExecutionBank?: string;

  /** Комиссии и расходы банка, обслуживающего счёт Получателя */
  expensesReceiverBank?: string;

  /** Комиссия за подтверждение аккредитива */
  expensesLcApprove?: string;

  /** Все комиссии и расходы по аккредитиву (всех банков) */
  expensesAll?: string;

  /** Порядок комиссий */
  expensesDescription?: string;

  /** ФИО контактного лица Приказодателя */
  contactName?: string;

  /** Телефон контактного лица Приказодателя */
  contactPhone?: string;

  /** Email контактного лица Приказодателя */
  contactEmail?: string;
}

export interface UpdateIntrarussianChangeRequest {
  /** Внутрироссийское заявление изменения аккредитива */
  applicationData?: StatementRussianChangeUpdate;
}

/**
 * Ответ о создании/обновлении заявления на изменение аккредитива
 */
export interface IntrarussianChangeUpdateResponse {
  /**
   * Id записи
   * @format uuid
   */
  applicationId?: string;
}

/**
 * Международное заявление изменения аккредитива
 */
export interface StatementInternationalChangeUpdate {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Идентификатор аккредитива */
  accId?: string;

  /** № аккредитива */
  accNumber?: string;

  /**
   * Дата аккредитива
   * @format date
   */
  accDate?: string;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /** Бенефициар */
  beneficiarName?: string;

  /** Бенефициар - адрес */
  beneficiarAddress?: string;

  /** Приказодатель - наименование */
  ordererName?: string;

  /** Приказодатель - адрес */
  ordererAddress?: string;

  /**
   * Дата истечения срока действия аккредитива
   * @format date
   */
  accExpireDate?: string;

  /** Место истечения срока действия аккредитива */
  accExpirePlace?: string;

  /** Увеличение суммы аккредитива */
  amountIncreaseValue?: number;

  /** Уменьшение суммы аккредитива */
  amountDecreaseValue?: number;

  /** Место принятия к перевозке/отправка из…/место получения груза для отправки */
  receiptPlace?: string;

  /** Порт загрузки/аэропорт отправления */
  loadingPort?: string;

  /** Место назначения */
  deliveryPlace?: string;

  /** Порт выгрузки/аэропорт назначения */
  unloadingPort?: string;

  /**
   * Последняя дата отгрузки
   * @format date
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки, с
   * @format date
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки, по
   * @format date
   */
  shippingPeriodEnd?: string;

  /** Признак разрешения частичных отгрузок */
  isPartialShipmentAllowed?: boolean;

  /** Признак разрешения перегрузок */
  isTranshipmentAllowed?: boolean;

  /** Описание товара */
  goodDescription?: string;

  /** Требуемые документы */
  requiredDocuments?: string;

  /** Дополнительные условия */
  additionalConditions?: string;

  /**
   * Идентификатор заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст со свободным описанием изменений */
  changeDescription?: string;

  /** Комиссии и расходы АО РСХБ - за счет приказодателя? */
  isCommisionsOrderer?: boolean;

  /** Комиссии и расходы вне территории Российской Федерации - за счет Бенефициара? */
  isCommisionsBeneficiar?: boolean;

  /** Все комиссии и расходы */
  expensesAll?: string;

  /** Описание иного порядка расходов */
  expensesDescription?: string;

  /**
   * Идентификатор счёта списания
   * @format uuid
   */
  writeOffAccountId?: string;

  /** При увеличении суммы покрытого аккредитива: списать средства? */
  isCoverIncreaseWriteOff?: boolean;

  /** При увеличении суммы покрытого аккредитива: списать средства в сумме увеличения аккредитива */
  coverIncreaseWriteOff?: number;

  /**
   * При увеличении суммы покрытого аккредитива: списать средства со счета № в АО РСХБ
   * @format uuid
   */
  coverIncreaseWriteOffAccountId?: string;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по кредитному договору/договору об открытии кредитной линии? */
  isCoverFromCredit?: boolean;

  /** № кредитного договора/договора об открытии кредитной линии */
  coverFromCreditNum?: string;

  /**
   * Дата кредитного договора/договора об открытии кредитной линии
   * @format date
   */
  coverFromCreditDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива? */
  isApplicationPartNonCovered?: boolean;

  /** № договора об открытии непокрытого аккредитива */
  applicationPartNonCoveredNum?: string;

  /**
   * Дата договора об открытии непокрытого аккредитива
   * @format date
   */
  applicationPartNonCoveredDate?: string;

  /** Настоящее заявление является неотъемлемой частью Ген. соглашения об открытии непокрытых аккредитивов? */
  isApplicationPartGeneral?: boolean;

  /** № ген. соглашения */
  applicationPartGeneralNum?: string;

  /**
   * Дата ген. соглашения
   * @format date
   */
  applicationPartGeneralDate?: string;

  /**
   * Контракт поставлен на учет в филиале АО РСХБ
   * @format uuid
   */
  contractRegisteredBranchId?: string;

  /** Тип валютного контроля */
  contractRegisteredType?:
    | "BRANCH_BANK"
    | "ANOTHER_BANK"
    | "NOT_SUBJECT_FOR_REGISTER";

  /** Контракт поставлен на учет: наименование банка */
  contractRegisteredAnotherBank?: string;

  /** УНК */
  unk?: string;

  /** Идентификаторы файлов вложения */
  attachments?: string[];

  /**
   * Период отгрузки (поле 44D, до 65 символов)
   * @example 01.05.2024 - 31.10.2024
   */
  shippingPeriod?: string;

  /** Рублевый счет для возврата покрытия */
  rubAcc?: string;

  /**
   * Дата УНК
   * @format date
   */
  unkDate?: string;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** ФИО контактного лица Приказодателя */
  contactName?: string;

  /** Телефон контактного лица Приказодателя */
  contactPhone?: string;

  /** Email контактного лица Приказодателя */
  contactEmail?: string;

  /** Предыдущее наименование Бенефициара */
  oldBeneficiaryName?: string;

  /**
   * Id Бенефициара из справочника
   * @format uuid
   */
  beneficiaryId?: string;

  /** Предыдущее наименование клиента */
  oldClientFullName?: string;

  /** Предыдущий адрес клиента */
  oldClientAddress?: string;
}

export interface UpdateInternationalChangeRequest {
  /** Международное заявление изменения аккредитива */
  applicationData?: StatementInternationalChangeUpdate;
}

/**
 * Ответ на правку международного заявление изменения аккредитива
 */
export interface InternationalChangeUpdateResponse {
  /**
   * Id записи
   * @format uuid
   */
  applicationdId?: string;
}

/**
 * Swift банк
 */
export interface Swift {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** SWIFT Код */
  swift?: string;

  /** Наименование банка */
  name?: string;

  /** Наименование страны */
  country?: string;

  /** Наименование города */
  city?: string;

  /** Адрес банка */
  address?: string;
}

/**
 * Swift банк
 */
export interface RuBank {
  /** @format uuid */
  id?: string;
  name?: string;
  bic?: string;
  swift?: string;
  placeType?: string;
  place?: string;
  address?: string;
  countryCode?: string;
  corrAccount?: string;
}

/**
 * Данные о счёте клиента
 */
export interface ClientAccount {
  /**
   * Идентификатор счёта
   * @format uuid
   */
  id?: string;

  /** Номер счёта */
  accountNumber?: string;

  /** Валюта счёта (трёхбуквенный код) */
  currency?: string;

  /**
   * Идентификатор владельца счёта (клиента)
   * @format uuid
   */
  ownerId?: string;

  /** Баланс счёта */
  balance?: number;

  /** Назначение счёта */
  purpose?: string;

  /** Тип счёта */
  type?: string;

  /**
   * Дата открытия счёта
   * @format date
   */
  openDate?: string;

  /**
   * Дата закрытия счёта
   * @format date
   */
  closeDate?: string;

  /** Признак наличия контракта на балансовый продукт на счёте */
  balanceContract?: boolean;
}

/**
 * Данные о счетах клиента
 */
export interface ClientAccountResponse {
  /** Данные о счетах клиента */
  accounts?: ClientAccount[];
}

/**
 * Филиалы банка
 */
export interface BranchResponse {
  /** Филиалы банка */
  branches?: Branch[];
}

/**
 * Детальная информация о клиенте
 */
export interface ClientDetails {
  /**
   * Идентификатор клиента
   * @format uuid
   */
  id?: string;

  /** Краткое наименование */
  shortName?: string;

  /** Краткое наименование на английском */
  shortNameLatin?: string;

  /** Полное наименование */
  fullName?: string;

  /** Полное наименование на английском */
  fullNameLatin?: string;

  /** Адрес */
  address?: string;

  /** Адрес на английском */
  addressLatin?: string;

  /** ФИО руководителя */
  chief?: string;

  /** ФИО главного бухгалтера */
  accChief?: string;

  /** ИНН */
  inn?: string;

  /** КПП */
  kpp?: string;

  /** КИО */
  kio?: string;

  /** ОГРН */
  ogrn?: string;

  /** ОКАТО */
  okato?: string;

  /** ОКПО */
  okpo?: string;

  /** Email */
  email?: string;

  /** Телефон */
  phone?: string;

  /** Факс */
  fax?: string;

  /** Страна */
  country?: string;

  /** Краткая организационно-правовая форма */
  opfShort?: string;

  /** Тип клиента */
  clientType?: string;

  /** Наименование органа регистрации */
  regBy?: string;

  /**
   * Дата регистрации
   * @format date
   */
  regDate?: string;

  /** VIP клиент */
  vip?: boolean;

  /**
   * Схема подписания для документов
   * @format int32
   */
  signCount?: number;

  /** Код филиала */
  branchCode?: string;

  /**
   * Идентификатор филиала
   * @format uuid
   */
  branchId?: string;

  /** Зона ответственности ССП */
  sspZone?: string;

  /** Итоговый сегмент клиента */
  finalSegment?: string;
}

/**
 * Информация об уполномоченном лице клиента
 */
export interface ClientDelegateDetails {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /**
   * Идентификатор организации
   * @format uuid
   */
  orgId?: string;

  /** Идентификатор субъекта в стороннем сервисе */
  userRefId?: string;

  /** Идентификатор пользователя в ЦФТ */
  cioId?: string;

  /** ФИО */
  fullName?: string;

  /** Признак неактивного пользователя */
  isNotActive?: boolean;

  /** Сигнатура полномочия */
  authoritySignature?: string;
}

/**
 * Разрешения на документ
 */
export interface PermissionsResponse {
  /** Тип документа */
  documentType?: string;

  /** Список разрешений для документа */
  permissions?: PermissionResponse[];
}

/**
 * Заявка на аккредитив
 */
export interface Order {
  /**
   * Идентификатор записи
   * @format uuid
   */
  id?: string;

  /** Тип аккредитива */
  type?: string;

  /**
   * Идентификатор заявления на аккредитив
   * @format uuid
   */
  applicationId?: string;

  /** Номер заявления на аккредитив */
  applicationNumber?: string;

  /** Способ формирования заявления */
  applicationMethod?: string;

  /** Статус исполнения заявки */
  status?: string;

  /** Описание статуса исполнения заявки или причина отказа */
  statusDescription?: string;

  /**
   * Дата и время создания заявки
   * @format date-time
   */
  createdDate?: string;

  /**
   * Дата и время отправки заявки в банк
   * @format date-time
   */
  applicationDate?: string;

  /** Полномочия */
  permissions?: PermissionResponse[];

  /**
   * Ссылка на клиента, который завёл заявку на аккредитив
   * @format uuid
   */
  clientId?: string;

  /** Информация о вложении */
  attachments?: AttachmentInfo[];

  /** Информация о клиенте */
  orderClientInfo?: OrderClientInfo;

  /** Данные о счёте клиента */
  clientAccountInfo?: ClientAccount;

  /** Данные счета */
  rubAccount?: StatementGetAccount;
}

/**
 * Список заявок
 */
export interface OrderList {
  /**
   * Общее количество заявок
   * @format int64
   */
  totalElements?: number;

  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Общее количество страниц
   * @format int32
   */
  totalPages?: number;

  /**
   * Текущая страница
   * @format int32
   */
  currentPage?: number;

  /**
   * Размер страницы
   * @format int32
   */
  pageSize?: number;

  /**
   * Статус операции
   * @example SUCCESS
   */
  status: string;

  /** Описание ошибки, если операция завершилась неуспешно */
  error?: string;

  /** Список заявок */
  orderList?: Order[];
}

/**
 * Поля ККБ
 */
export type CcbFields = object;

/**
 * Документ
 */
export interface DocumentOrderCcbResponse {
  /** Тип документа */
  type?: DocumentTypeOrderCcbResponse;

  /** Поля ККБ */
  fields?: CcbFields;
}

/**
 * Тип документа
 */
export interface DocumentTypeOrderCcbResponse {
  /** Наименование документа */
  name?: string;

  /** Описание документа */
  desc?: string;
}

/**
 * Получение ккб конкретного документа
 */
export interface OrderCcbResponse {
  /** Статус */
  status: "SUCCESS" | "FAILURE";

  /**
   * Код ошибки
   * @format int32
   */
  errorCode?: number;

  /** Описание ошибки */
  errorText?: string;

  /** Наличие подписантов */
  signData?: SignData;

  /** Документ ККБ */
  ccb?: string;

  /** Версия ККБ */
  ccbVersion?: string;

  /** Документ */
  document?: DocumentOrderCcbResponse;
}

/**
 * Ответ на запрос получения заявления на международный аккредитив
 */
export interface InternationalGetResponse {
  /** Статус выполнения запроса */
  status: string;

  /**
   * Идентификатор заявления
   * @format uuid
   */
  applicationId?: string;

  /**
   * Код ошибки
   * @format int32
   */
  errorCode?: number;

  /** Сообщение об ошибке */
  errorText?: string;

  /** Наличие подписантов */
  signData?: SignData;

  /** Данные деталки международного заявление на аккредитив */
  applicationData?: StatementGetInternational;

  /**
   * Id получателя
   * @format uuid
   */
  receiverId?: string;

  /** Вид клиента получателя */
  receiverType?: string;

  /** Организационно-правовая форма/Правовой статус/Вид деятельности получателя */
  receiverStatus?: string;

  /** Полное или сокращённое наименование/ФИО получателя */
  receiverName?: string;

  /** ИНН получателя */
  receiverInn?: string;

  /**
   * Дата рождения получателя
   * @format date
   */
  receiverBirthDate?: string;

  /** Место рождения получателя */
  receiverBirthPlace?: string;

  /** Реквизиты документа, удостоверяющего личность получателя */
  receiverDocument?: string;

  /** Адрес/Адрес регистрации получателя */
  receiverRegistrationAddress?: string;

  /** Адрес фактического проживания получателя */
  receiverFactAddress?: string;

  /** Номер счёта получателя */
  receiverAccountNumber?: string;

  /** Идентификатор аккредитива в ЦФТ */
  letterCreditId?: string;

  /** Информация о клиенте */
  orderClientInfo?: OrderClientInfo;
}

/**
 * Данные деталки международного заявление на аккредитив
 */
export interface StatementGetInternational {
  /**
   * Id документа
   * @format uuid
   */
  id?: string;

  /**
   * Id клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Id заявки
   * @format uuid
   */
  orderId?: string;

  /** Аккредитив покрытый/непокрытый */
  isAccreditivCover?: boolean;

  /** Источник финансирования */
  financingSource?: string;

  /** Признак указания данных тратты Бенефициара */
  isDraft?: boolean;

  /** Срок тратты */
  draftUntil?: string;

  /** Идентификатор банка тратты */
  draftBankId?: string;

  /** Банк-эмитент */
  issuerBankId?: string;

  /** Толеранс: процент увеличения */
  tolerancePercentIncrease?: number;

  /** Толеранс: процент уменьшения */
  tolerancePercentDecrease?: number;

  /** Инструкции подтверждения */
  confirmationInstruction?: string;

  /** Подтверждающий банк */
  confirmationBankId?: string;

  /** Признак выбора подтверждающего банка на усмотрение Росчсельхозбанка */
  isConfirmBankByRshb?: boolean;

  /** Исполняющий банк */
  executionBank?: string;

  /** Id исполняющего банка */
  executionBankId?: string;

  /** Способ исполнения */
  executionPath?: string;

  /** Детали отсрочки платежа */
  deferredPaymentDetails?: string;

  /** Частичные отгрузки разрешены */
  isPartialShipmentAllowed?: boolean;

  /** Перегрузка разрешена */
  isTranshipmentAllowed?: boolean;

  /** Место принятия к перевозке */
  receiptPlace?: string;

  /** Место назначения */
  deliveryPlace?: string;

  /** Порт погрузки */
  loadingPort?: string;

  /** Порт выгрузки */
  unloadingPort?: string;

  /** Описание товара */
  goodDescription?: string;

  /**
   * Последняя дата отгрузки
   * @format date
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки с
   * @format date
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки по
   * @format date
   */
  shippingPeriodEnd?: string;

  /** Условия поставки */
  shippingDetails?: string;

  /** Комиссии и расходы */
  commissionExpenses?: string;

  /** Частичные выплаты */
  partialPayments?: string;

  /** Вид коммерческого договора */
  contractType?: string;

  /** Номер контракта */
  contractNumber?: string;

  /**
   * Дата контракта
   * @format date
   */
  contractDate?: string;

  /** Дополнительная информация */
  additionalInformation?: string;

  /** Трассат */
  drafted?: string;

  /** Условие тратт */
  draftCondition?: string;

  /** Покрытие в сумме аккредитива просим списать со счета Приказодателя */
  isWriteOffFromAccount?: boolean;

  /** Данные счета */
  writeOffAccount?: StatementGetAccount;

  /** Покрытие просим сформировать за счет кредитных средств Банка */
  isCoverFormsFromCredit?: boolean;

  /** Тип документа */
  coverDocumentType?: string;

  /** № договора */
  coverDocumentNum?: string;

  /**
   * Дата договора
   * @format date
   */
  coverDocumentDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора */
  isApplicationContractPart?: boolean;

  /** Номер договора */
  partContractNum?: string;

  /**
   * Дата договора
   * @format date
   */
  partContractDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения */
  isGeneralNegotiation?: boolean;

  /** № ген. соглашения */
  negotiationNumber?: string;

  /**
   * Дата ген. соглашения
   * @format date
   */
  negotiationDate?: string;

  /** Установить срок возмещения */
  isSetRefundPeriod?: boolean;

  /**
   * Срок возмещения
   * @format int32
   */
  refundPeriod?: number;

  /** Порядок оплаты комиссий и расходов */
  expensesMethod?: string;

  /** Комиссии и расходы банка-эмитента */
  expensesEmitentBank?: string;

  /** Комиссии и расходы вне территории РФ */
  expensesForeign?: string;

  /** Все комиссии и расходы */
  expensesAll?: string;

  /** Описание иного порядка расходов */
  expensesDescription?: string;

  /** Данные счета */
  expensesAccount?: StatementGetAccount;

  /** Тип допуска */
  toleranceType?: string;

  /** Телефон контактного лица Приказодателя */
  contactPhone?: string;

  /** Эл.почта контактного лица Приказодателя */
  contactEmail?: string;

  /** Величина допуска */
  toleranceAmount?: number;

  /** Сумма */
  amountValue?: number;

  /** Валюта денежной суммы */
  amountCurrency?: string;

  /** Сумма прописью */
  amountFormulation?: string;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /**
   * Id Бенефициара из справочника
   * @format uuid
   */
  beneficiaryId?: string;

  /** Наименование Бенефициара */
  beneficiaryName?: string;

  /** Адрес Бенефициара */
  beneficiaryAddress?: string;

  /** Номер счёта Бенефициара */
  beneficiaryAccountNum?: string;

  /** Id авизующего банка */
  advisingBankId?: string;

  /** Вид аккредитива */
  letterCreditKind?: string;

  /** Контактное лицо Приказодателя */
  contactName?: string;

  /** Требуемые документы */
  requiredDocuments?: string;

  /**
   * Требуемые документы (оригиналы)
   * @format int32
   */
  requiredDocumentsOrig?: number;

  /**
   * Требуемые документы (копии)
   * @format int32
   */
  requiredDocumentsCopy?: number;

  /** Признак, что клиент ознакомлен и согласен с положениями на заведение аккредитива */
  isClientApproves?: boolean;

  /** Список исполненных документов */
  executingDocuments?: ExecutingInternationalDocument[];

  /**
   * Дата истечения срока действия аккредитива
   * @format date
   */
  untilDate?: string;

  /** Место истечения срока действия аккредитива */
  untilPlace?: string;

  /** Требуемые документы */
  documentNeed?: string;

  /** Срок предоставления документов */
  documentProvisionPeriod?: string;

  /** Способ предоставления документов */
  documentProvisionMethod?: string;

  /** Дополнительные условия */
  additionalConditions?: string;

  /** Статус заявки */
  orderStatus?: string;

  /** Причина отказа */
  rejectReason?: string;

  /**
   * Id заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст со свободным описанием изменений */
  changeDescription?: string;

  /** КПП платильщика */
  payerKpp?: string;

  /** УНК */
  unk?: string;

  /**
   * Id филиала, где договор поставлен на учет
   * @format uuid
   */
  contractRegisteredBranchId?: string;

  /** Филиал банка */
  contractRegisteredBranch?: Branch;

  /** Тип валютного контроля */
  contractRegisteredType?:
    | "BRANCH_BANK"
    | "ANOTHER_BANK"
    | "NOT_SUBJECT_FOR_REGISTER";

  /** Договор поставлен на учет. Наименование иного уполномоченного банка */
  contractRegisteredAnotherBank?: string;

  /** Полномочия */
  permissions?: PermissionResponse[];

  /** Дополнительные условия */
  otherConditions?: OtherCondition[];

  /** Дополнительные инструкции */
  otherInstructions?: OtherInstruction[];

  /** Информация о вложении */
  attachments?: AttachmentInfo[];

  /**
   * Период отгрузки (поле 44D, до 65 символов)
   * @example 01.05.2024 - 31.10.2024
   */
  shippingPeriod?: string;

  /**
   * Дата УНК
   * @format date
   */
  unkDate?: string;

  /** Данные счета */
  rubAccount?: StatementGetAccount;

  /**
   * Невозможность завершения расчетов по аккредитиву в связи с возникновением  ограничений
   * @example true
   */
  isInabilityCompleteCalc?: boolean;

  /**
   * Приказодатель проинформирован
   * @example true
   */
  isApplicantInformed?: boolean;
}

export interface StatusFile {
  isReady?: boolean;
}

export interface LcConfirmTypeResponse {
  confirmType?: string;
}

export interface LcClientCertificateResponse {
  serial?: string;
  issuer?: string;
  userId?: string;
  clientId?: string;
}

/**
 * Данные внутрироссийского заявления на изменение аккредитива
 */
export interface IntrarussianChangeResponse {
  /**
   * Id записи
   * @format uuid
   */
  id?: string;

  /** Номер аккредитива */
  accNumber?: string;

  /**
   * Дата аккредитива
   * @format date
   */
  accDate?: string;

  /** Номер заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /**
   * Плательщик - это Клиент
   * @format uuid
   */
  clientId?: string;

  /**
   * Id заявки
   * @format uuid
   */
  orderId?: string;

  /** Получатель */
  receiverName?: string;

  /** комиссии и расходы АО «Россельхозбанк» - за счет получателя */
  isCommisionsReceiver?: boolean;

  /** Комиссии и расходы исполняющего банка */
  executuingBankCommission?: string;

  /** Комиссии и расходы банка получателя */
  receiverCommisions?: string;

  /** Иные условия оплаты комиссий и расходов */
  otherCommissionConditions?: string;

  /** При увеличении суммы покрытого аккредитива: списать средства */
  isCoverIncreaseWriteOff?: boolean;

  /** При увеличении суммы покрытого аккредитива: списать средства в сумме увеличения аккредитива */
  coverIncreaseWriteOff?: number;

  /** Данные счета */
  coverIncreaseWriteOffAccount?: StatementGetAccount;

  /** Филиал банка */
  coverIncreaseWriteOffBranch?: Branch;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по кредитному договору/договору об открытии кредитной линии */
  isCoverFromCredit?: boolean;

  /** № кредитного договора/договора об открытии кредитной линии */
  coverFromCreditNum?: string;

  /**
   * Дата кредитного договора/договора об открытии кредитной линии
   * @format date
   */
  coverFromCreditDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива? */
  isApplicationPartNonCovered?: boolean;

  /** № договора об открытии непокрытого аккредитива */
  applicationPartNonCoveredNum?: string;

  /**
   * Дата договора об открытии непокрытого аккредитива
   * @format date
   */
  applicationPartNonCoveredDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения об открытии непокрытых аккредитивов? */
  isApplicationPartGeneral?: boolean;

  /** № генерального соглашения */
  applicationPartGeneralNum?: string;

  /**
   * Дата генерального соглашения
   * @format date
   */
  applicationPartGeneralDate?: string;

  /** Данные счета */
  defaultWriteOffAccount?: StatementGetAccount;

  /** Филиал банка */
  defaultWriteOffAccountBranch?: Branch;

  /**
   * Id заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст со свободным описанием изменений */
  changeDescription?: string;

  /** Статус заявления на изменение */
  orderChangeStatus?:
    | "NEW"
    | "PREPARED"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT"
    | "WAIT_PROCESSING_BY_BANK"
    | "PROCESSING_BY_BANK"
    | "EXECUTED"
    | "REJECTED"
    | "REVOKED";

  /** Полномочия */
  permissions?: PermissionResponse[];

  /** Подписанты */
  signers?: StatementSigner[];

  /** ИНН приказодателя */
  ordererInn?: string;

  /** КПП приказодателя */
  ordererKpp?: string;

  /** Почта приказодателя */
  ordererEmail?: string;

  /** Телефон приказодателя */
  ordererPhone?: string;

  /** Филиал банка */
  ordererBranchCode?: Branch;

  /** Информация о вложении */
  attachments?: AttachmentInfo[];

  /** Причина отказа */
  rejectReason?: string;

  /** Описание ошибки от ЦФТ */
  cftErrorDescription?: string;

  /** Установлен срок возмещения */
  isSetRefundPeriod?: boolean;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** Порядок оплаты комиссий и расходов */
  expensesMethod?: string;

  /** Комиссии и расходы банка-эмитента */
  expensesEmitentBank?: string;

  /** Комиссии и расходы Исполняющего банка */
  expensesExecutionBank?: string;

  /** Комиссии и расходы банка, обслуживающего счёт Получателя */
  expensesReceiverBank?: string;

  /** Комиссия за подтверждение аккредитива */
  expensesLcApprove?: string;

  /** Все комиссии и расходы по аккредитиву (всех банков) */
  expensesAll?: string;

  /** Порядок комиссий */
  expensesDescription?: string;

  /** ФИО контактного лица Приказодателя */
  contactName?: string;

  /** Телефон контактного лица Приказодателя */
  contactPhone?: string;

  /** Email контактного лица Приказодателя */
  contactEmail?: string;
}

/**
 * Сведения о подписанте заявления
 */
export interface StatementSigner {
  /** Название клиента */
  shortName?: string;

  /** ФИО */
  fullName?: string;

  /** Неактивен? */
  isNotActive?: boolean;
}

/**
 * Данные международного заявления на изменение аккредитива
 */
export interface InternationalChangeResponse {
  /**
   * Id записи
   * @format uuid
   */
  id?: string;

  /**
   * Id клиента
   * @format uuid
   */
  clientId?: string;

  /**
   * Id заявки
   * @format uuid
   */
  orderId?: string;

  /** № аккредитива */
  accNumber?: string;

  /**
   * Дата аккредитива
   * @format date
   */
  accDate?: string;

  /** № заявления */
  applicationNumber?: string;

  /**
   * Дата заявления
   * @format date-time
   */
  applicationDate?: string;

  /**
   * Дата подписания
   * @format date
   */
  signedDate?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /** Бенефициар */
  beneficiarName?: string;

  /** Бенефициар - адрес */
  beneficiarAddress?: string;

  /** Приказодатель - наименование */
  ordererName?: string;

  /** Приказодатель - адрес */
  ordererAddress?: string;

  /**
   * Дата истечения срока действия аккредитива
   * @format date
   */
  accExpireDate?: string;

  /** Место истечения срока действия аккредитива */
  accExpirePlace?: string;

  /** Увеличение суммы аккредитива */
  amountIncreaseValue?: number;

  /** Уменьшение суммы аккредитива */
  amountDecreaseValue?: number;

  /** Место принятия к перевозке/отправка из…/место получения груза для отправки */
  receiptPlace?: string;

  /** Порт загрузки/аэропорт отправления */
  loadingPort?: string;

  /** Место назначения */
  deliveryPlace?: string;

  /** Порт выгрузки/аэропорт назначения */
  unloadingPort?: string;

  /**
   * Последняя дата отгрузки
   * @format date
   */
  lastShippingDate?: string;

  /**
   * Период отгрузки, с
   * @format date
   */
  shippingPeriodStart?: string;

  /**
   * Период отгрузки, по
   * @format date
   */
  shippingPeriodEnd?: string;

  /** Признак разрешения частичных отгрузок */
  isPartialShipmentAllowed?: boolean;

  /** Признак разрешения перегрузок */
  isTranshipmentAllowed?: boolean;

  /** Описание товара */
  goodDescription?: string;

  /** Требуемые документы */
  requiredDocuments?: string;

  /** Дополнительные условия */
  additionalConditions?: string;

  /**
   * Id заявления изменяемого аккредитива
   * @format uuid
   */
  previousOrderId?: string;

  /** Текст со свободным описанием изменений */
  changeDescription?: string;

  /** Комиссии и расходы АО «Россельхозбанк» - за счет приказодателя? */
  isCommisionsOrderer?: boolean;

  /** Комиссии и расходы вне территории Российской Федерации - за счет Бенефициара? */
  isCommisionsBeneficiar?: boolean;

  /** Все комиссии и расходы */
  expensesAll?: string;

  /** Описание иного порядка расходов */
  expensesDescription?: string;

  /** Данные счета */
  writeOffAccount?: StatementGetAccount;

  /** При увеличении суммы покрытого аккредитива: списать средства? */
  isCoverIncreaseWriteOff?: boolean;

  /** При увеличении суммы покрытого аккредитива: списать средства в сумме увеличения аккредитива */
  coverIncreaseWriteOff?: number;

  /** Данные счета */
  coverIncreaseWriteOffAccount?: StatementGetAccount;

  /** Покрытие просим сформировать за счет кредитных средств Банка, предоставляемых по кредитному договору/договору об открытии кредитной линии? */
  isCoverFromCredit?: boolean;

  /** № кредитного договора/договора об открытии кредитной линии */
  coverFromCreditNum?: string;

  /**
   * Дата кредитного договора/договора об открытии кредитной линии
   * @format date
   */
  coverFromCreditDate?: string;

  /** Настоящее заявление является неотъемлемой частью Договора об открытии непокрытого аккредитива? */
  isApplicationPartNonCovered?: boolean;

  /** № договора об открытии непокрытого аккредитива */
  applicationPartNonCoveredNum?: string;

  /**
   * Дата договора об открытии непокрытого аккредитива
   * @format date
   */
  applicationPartNonCoveredDate?: string;

  /** Настоящее заявление является неотъемлемой частью Генерального соглашения об открытии непокрытых аккредитивов? */
  isApplicationPartGeneral?: boolean;

  /** № генерального соглашения */
  applicationPartGeneralNum?: string;

  /**
   * Дата генерального соглашения
   * @format date
   */
  applicationPartGeneralDate?: string;

  /** Филиал банка */
  contractRegisteredBranch?: Branch;

  /** Контракт поставлен на учет: наименование банка */
  contractRegisteredAnotherBank?: string;

  /** УНК */
  unk?: string;

  /** Тип валютного контроля */
  contractRegisteredType?:
    | "BRANCH_BANK"
    | "ANOTHER_BANK"
    | "NOT_SUBJECT_FOR_REGISTER";

  /** Статус заявления на изменение */
  orderChangeStatus?:
    | "NEW"
    | "PREPARED"
    | "PARTIALLY_SIGNED"
    | "SIGNED"
    | "SENT"
    | "WAIT_PROCESSING_BY_BANK"
    | "PROCESSING_BY_BANK"
    | "EXECUTED"
    | "REJECTED"
    | "REVOKED";

  /** Полномочия */
  permissions?: PermissionResponse[];

  /** Подписанты */
  signers?: StatementSigner[];

  /** Информация о вложении */
  attachments?: AttachmentInfo[];

  /** Причина отказа */
  rejectReason?: string;

  /** Описание ошибки от ЦФТ */
  cftErrorDescription?: string;

  /**
   * Период отгрузки (поле 44D, до 65 символов)
   * @example 01.05.2024 - 31.10.2024
   */
  shippingPeriod?: string;

  /**
   * Дата УНК
   * @format date
   */
  unkDate?: string;

  /** Данные счета */
  rubAccount?: StatementGetAccount;

  /** Тип документа покрытия */
  coverDocumentType?: string;

  /** ФИО контактного лица Приказодателя */
  contactName?: string;

  /** Телефон контактного лица Приказодателя */
  contactPhone?: string;

  /** Email контактного лица Приказодателя */
  contactEmail?: string;

  /** Предыдущее наименование Бенефициара */
  oldBeneficiaryName?: string;

  /**
   * Id Бенефициара из справочника
   * @format uuid
   */
  beneficiaryId?: string;

  /** Предыдущее наименование клиента */
  oldClientFullName?: string;

  /** Предыдущий адрес клиента */
  oldClientAddress?: string;
}

/**
 * Запись в истории изменений документа
 */
export interface History {
  /**
   * Дата и время в таймзоне филиала клиента
   * @format date-time
   */
  createDate?: string;

  /** Представитель клиента */
  clientDelegateName?: string;

  /** Сотрудник */
  employeeName?: string;

  /** Новый статус */
  newStatus?: string;
}

/**
 * Ответ на запрос истории изменений документа
 */
export interface HistoryResponse {
  /** История изменений документа */
  history?: History[];
}

/**
 * DTO для валюты (acc_r_currency)
 */
export interface Currency {
  /**
   * Идентификатор валюты
   * @format uuid
   */
  id?: string;

  /** Наименование валюты ISO */
  name?: string;

  /** Буквенный код валюты ISO */
  alphabeticCode?: string;

  /** Цифровой код валюты ISO */
  numericCode?: string;

  /** Наименование валюты ОКВ */
  okvName?: string;

  /** Активна ли валюта */
  isActive?: boolean;

  /**
   * Количество минорных единиц
   * @format int32
   */
  accuracy?: number;
}

/**
 * Результат проверки статуса отправленного запроса получения данных по аккредитивам из АБС ЦФТ
 */
export interface GetInfoAccreditiveClientLEResponseCheck {
  /** Список аккредитивов */
  letterCreditList?: LetterCreditList;

  /** Статус запроса */
  isReceived?: boolean;

  /**
   * Дата и время ответа
   * @format date-time
   */
  responseDateTime?: string;

  /**
   * Общее количество заявок
   * @format int64
   */
  totalElements?: number;

  /** Наличие следующих страниц */
  hasMore?: boolean;

  /**
   * Общее количество страниц
   * @format int32
   */
  totalPages?: number;

  /**
   * Текущая страница
   * @format int32
   */
  currentPage?: number;

  /**
   * Размер страницы
   * @format int32
   */
  pageSize?: number;
}

/**
 * Инфорамция по аккредитиву
 */
export interface LetterCredit {
  /** Идентификатор аккредитива в ЦФТ */
  id?: string;

  /** Применяемые правила аккредитива */
  rule?: string;

  /** Тип аккредитива */
  type?: string;

  /** Наименование типа аккредитива в ЦФТ */
  nameType?: string;

  /** Номер аккредитива */
  number?: string;

  /** Наименование банка-эмитента */
  issuerBankName?: string;

  /** Наименование бенефициара (контрагента) */
  beneficiaryName?: string;

  /**
   * Дата истечения срока действия аккредитива
   * @format date
   */
  expirationDate?: string;

  /** Срок предоставления документов */
  provisionDocumentPeriod?: string;

  /** Статус аккредитива */
  status?: string;

  /** Референс аккредитива в ДБО */
  reference?: string;

  /** Сумма аккредитива */
  amountValue?: number;

  /** Валюта аккредитива */
  amountCurrency?: string;

  /**
   * Идентификатор заявки на открытие аккредитива
   * @format uuid
   */
  orderId?: string;

  /** Наименование клиента */
  clientFullName?: string;

  /** Адрес клиента */
  clientAddress?: string;

  /** @format date */
  accreditivBeginingDate?: string;
  accreditivReferenceRSHB?: string;
}

/**
 * Список аккредитивов
 */
export interface LetterCreditList {
  /** Список аккредитивов */
  letterCredit?: LetterCredit[];
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис owb-ms-prd-accreditivs
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl http://localhost:8080
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Микросервис owb-ms-prd-accreditivs <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=328820724)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Работа с заявками на аккредитив
     * @name GetOrderById
     * @summary Получение заявки по идентификатору
     * @request GET:/api/accreditivs/v1/external/orders/{id}
     * @secure
     */
    getOrderById: (id: string, params: RequestParams = {}) =>
      this.request<Order, GenericError | void>({
        path: `/api/accreditivs/v1/external/orders/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на аккредитив
     * @name UpdateOrder
     * @summary Обновление заявки
     * @request PUT:/api/accreditivs/v1/external/orders/{id}
     * @secure
     */
    updateOrder: (id: string, data: OrderUpdate, params: RequestParams = {}) =>
      this.request<OrderResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/orders/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на аккредитив
     * @name DeleteOrder
     * @summary Удаление заявления и заявки по указанной заявке
     * @request DELETE:/api/accreditivs/v1/external/orders/{id}
     * @secure
     */
    deleteOrder: (id: string, params: RequestParams = {}) =>
      this.request<void, GenericError | void>({
        path: `/api/accreditivs/v1/external/orders/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на аккредитив
     * @name GetOrderList
     * @summary Получение списка заявок
     * @request GET:/api/accreditivs/v1/external/orders
     * @secure
     */
    getOrderList: (
      query?: {
        page?: number;
        size?: number;
        letterCreditType?: string;
        status?: string[];
        startDate?: string;
        endDate?: string;
      },
      params: RequestParams = {}
    ) =>
      this.request<OrderList, GenericError | void>({
        path: `/api/accreditivs/v1/external/orders`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявками на аккредитив
     * @name CreateOrder
     * @summary Создание заявки
     * @request POST:/api/accreditivs/v1/external/orders
     * @secure
     */
    createOrder: (data: OrderRequest, params: RequestParams = {}) =>
      this.request<OrderResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/orders`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name UploadFile
     * @summary Загрузка файла клиентом
     * @request POST:/api/accreditivs/v1/external/letterCreditOrder/uploadContract
     * @secure
     */
    uploadFile: (data: { file: File }, params: RequestParams = {}) =>
      this.request<AttachmentUploadResponse, any>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/uploadContract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.FormData,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name UpdateIntrarussian
     * @summary Редактирование заявления на внутрироссийский аккредитив
     * @request POST:/api/accreditivs/v1/external/letterCreditOrder/updateIntrarussian
     * @secure
     */
    updateIntrarussian: (
      data: UpdateIntrarussianRequest,
      query?: { isDraft?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<IntrarussianResponse, ValidationError | GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/updateIntrarussian`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name UpdateInternational
     * @summary Редактирование заявления на международный аккредитив
     * @request POST:/api/accreditivs/v1/external/letterCreditOrder/updateInternational
     * @secure
     */
    updateInternational: (
      data: UpdateInternationalRequest,
      query?: { isDraft?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<InternationalResponse, ValidationError | GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/updateInternational`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name CloneOrder
     * @summary Создание копии заявки
     * @request POST:/api/accreditivs/v1/external/letterCreditOrder/cloneOrder/{orderId}
     * @secure
     */
    cloneOrder: (orderId: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/cloneOrder/${orderId}`,
        method: "POST",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name UpdateIntrarussianChange
     * @summary Редактирование заявления изменений внутрироссийского аккредитива
     * @request POST:/api/accreditivs/v1/external/letterCreditChangeOrder/updateIntrarussianChange
     * @secure
     */
    updateIntrarussianChange: (
      data: UpdateIntrarussianChangeRequest,
      query?: { isDraft?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        IntrarussianChangeUpdateResponse,
        ValidationError | GenericError
      >({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/updateIntrarussianChange`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name UpdateInternationalChange
     * @summary Редактирование заявления изменений международного аккредитива
     * @request POST:/api/accreditivs/v1/external/letterCreditChangeOrder/updateInternationalChange
     * @secure
     */
    updateInternationalChange: (
      data: UpdateInternationalChangeRequest,
      query?: { isDraft?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<
        InternationalChangeUpdateResponse,
        ValidationError | GenericError
      >({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/updateInternationalChange`,
        method: "POST",
        query: query,
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name GetSwiftBanks
     * @summary Получение списка SWIFT банков
     * @request GET:/api/accreditivs/v1/external/reference/swift
     * @secure
     */
    getSwiftBanks: (
      query: { searchText: string },
      params: RequestParams = {}
    ) =>
      this.request<Swift[], GenericError>({
        path: `/api/accreditivs/v1/external/reference/swift`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name GetRuBanks
     * @summary Получение списка Российских банков
     * @request GET:/api/accreditivs/v1/external/reference/ru-bank
     * @secure
     */
    getRuBanks: (query: { searchText: string }, params: RequestParams = {}) =>
      this.request<RuBank[], GenericError>({
        path: `/api/accreditivs/v1/external/reference/ru-bank`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name ListClientAccount
     * @summary Список счетов текущего клиента
     * @request GET:/api/accreditivs/v1/external/reference/listClientAccount
     * @secure
     */
    listClientAccount: (
      query?: { russianCurrency?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<ClientAccountResponse, void | GenericError>({
        path: `/api/accreditivs/v1/external/reference/listClientAccount`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name ListBranch
     * @summary Список филиалов банка
     * @request GET:/api/accreditivs/v1/external/reference/listBranch
     * @secure
     */
    listBranch: (
      query?: { isOnlyParents?: boolean },
      params: RequestParams = {}
    ) =>
      this.request<BranchResponse, void | GenericError>({
        path: `/api/accreditivs/v1/external/reference/listBranch`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name GetClientById
     * @summary Получение информации о клиенте
     * @request GET:/api/accreditivs/v1/external/reference/client
     * @secure
     */
    getClientById: (params: RequestParams = {}) =>
      this.request<ClientDetails, void | GenericError>({
        path: `/api/accreditivs/v1/external/reference/client`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с внешними справочниками
     * @name GetDelegateById
     * @summary Получение информации об уполномоченном лице
     * @request GET:/api/accreditivs/v1/external/reference/client-delegate/{id}
     * @secure
     */
    getDelegateById: (id: string, params: RequestParams = {}) =>
      this.request<ClientDelegateDetails, void | GenericError>({
        path: `/api/accreditivs/v1/external/reference/client-delegate/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Получение разрешений на документ по его типу
     * @name GetPermissionByDocumentType
     * @summary Получение разрешений на документ
     * @request GET:/api/accreditivs/v1/external/permissions/{documentType}
     * @secure
     */
    getPermissionByDocumentType: (
      documentType: string,
      params: RequestParams = {}
    ) =>
      this.request<PermissionsResponse, void>({
        path: `/api/accreditivs/v1/external/permissions/${documentType}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name IntrarussianReport
     * @summary Печать внутрироссийского заявления
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/printRussian/{orderId}
     * @secure
     */
    intrarussianReport: (orderId: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/printRussian/${orderId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name ForeignReport
     * @summary Печать международного заявления
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/printForeign/{orderId}
     * @secure
     */
    foreignReport: (orderId: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/printForeign/${orderId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание заявления
     * @name GetSignInfo
     * @summary Получение контрольного крипто-блока для подписания заявления
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getSignInfo
     * @secure
     */
    getSignInfo: (
      query: { orderId: string; documentType: string },
      params: RequestParams = {}
    ) =>
      this.request<OrderCcbResponse, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getSignInfo`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name GetIntrarussian
     * @summary Получение данных заявления на внутрироссийский аккредитив
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getIntrarussian
     * @secure
     */
    getIntrarussian: (
      query?: { applicationId?: string; orderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<IntrarussianResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getIntrarussian`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями на аккредитив
     * @name GetInternational
     * @summary Получение данных заявления на международный аккредитив
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getInternational
     * @secure
     */
    getInternational: (
      query?: { applicationId?: string; orderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<InternationalGetResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getInternational`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name GetStatusFile
     * @summary Получение статуса файла в файловом хранилище
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getFileStatus
     * @secure
     */
    getStatusFile: (query: { fileId: string }, params: RequestParams = {}) =>
      this.request<StatusFile, any>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getFileStatus`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание заявления
     * @name GetConfirmType
     * @summary Получение типа подтверждения
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getConfirmType
     * @secure
     */
    getConfirmType: (params: RequestParams = {}) =>
      this.request<LcConfirmTypeResponse, any>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getConfirmType`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Подписание заявления
     * @name GetClientCertificate
     * @summary Получение доступного сертификата клиента
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/getClientCertificate
     * @secure
     */
    getClientCertificate: (params: RequestParams = {}) =>
      this.request<LcClientCertificateResponse, any>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/getClientCertificate`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Вложения
     * @name DownloadAttachments
     * @summary Получение файлов вложения
     * @request GET:/api/accreditivs/v1/external/letterCreditOrder/downloadAttachments
     * @secure
     */
    downloadAttachments: (
      query: { attachmentIds: string[] },
      params: RequestParams = {}
    ) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditOrder/downloadAttachments`,
        method: "GET",
        query: query,
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name IntrarussianChangeReport
     * @summary Печать на изменение внутрироссийского заявления
     * @request GET:/api/accreditivs/v1/external/letterCreditChangeOrder/printRussianChange/{orderId}
     * @secure
     */
    intrarussianChangeReport: (orderId: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/printRussianChange/${orderId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name ForeignChangeReport
     * @summary Печать на изменение международного заявления
     * @request GET:/api/accreditivs/v1/external/letterCreditChangeOrder/printForeignChange/{orderId}
     * @secure
     */
    foreignChangeReport: (orderId: string, params: RequestParams = {}) =>
      this.request<File, GenericError>({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/printForeignChange/${orderId}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name GetIntrarussian1
     * @summary Загрузка внутрироссийского заявления на изменение
     * @request GET:/api/accreditivs/v1/external/letterCreditChangeOrder/getIntrarussianChange
     * @secure
     */
    getIntrarussian1: (
      query?: { applicationId?: string; orderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<IntrarussianChangeResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/getIntrarussianChange`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Работа с заявлениями изменения аккредитива
     * @name GetInternational1
     * @summary Загрузка международного заявления на изменение
     * @request GET:/api/accreditivs/v1/external/letterCreditChangeOrder/getInternationalChange
     * @secure
     */
    getInternational1: (
      query?: { applicationId?: string; orderId?: string },
      params: RequestParams = {}
    ) =>
      this.request<InternationalChangeResponse, GenericError | void>({
        path: `/api/accreditivs/v1/external/letterCreditChangeOrder/getInternationalChange`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags История документа
     * @name GetHistory
     * @summary Получение истории документа
     * @request GET:/api/accreditivs/v1/external/history/{documentType}/{documentId}
     * @secure
     */
    getHistory: (
      documentType: string,
      documentId: string,
      params: RequestParams = {}
    ) =>
      this.request<HistoryResponse, void>({
        path: `/api/accreditivs/v1/external/history/${documentType}/${documentId}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валют (acc_r_currency) — внешние методы
     * @name GetAll
     * @summary Получить список всех валют (read-only, external)
     * @request GET:/api/accreditivs/v1/external/currency
     * @secure
     */
    getAll: (params: RequestParams = {}) =>
      this.request<Currency[], void | GenericError>({
        path: `/api/accreditivs/v1/external/currency`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Справочник валют (acc_r_currency) — внешние методы
     * @name GetById
     * @summary Получить валюту по ID (read-only, external)
     * @request GET:/api/accreditivs/v1/external/currency/{id}
     * @secure
     */
    getById: (id: string, params: RequestParams = {}) =>
      this.request<Currency, void | GenericError>({
        path: `/api/accreditivs/v1/external/currency/${id}`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Интеграция с АБС
     * @name GetInfoAccreditiveClientLeResponseCheck
     * @summary Метод проверяет наличие ответа на запрос получения данных по аккредитивам из АБС ЦФТ
     * @request GET:/api/accreditivs/v1/external/abs/getAccreditivList
     * @secure
     */
    getInfoAccreditiveClientLeResponseCheck: (
      query?: {
        accreditivRule?: string;
        accreditivType?: string;
        issuerBankName?: string;
        beneficiaryName?: string;
        accreditivStatus?: string[];
        currencyCode?: string[];
        page?: number;
        size?: number;
      },
      params: RequestParams = {}
    ) =>
      this.request<GetInfoAccreditiveClientLEResponseCheck, GenericError>({
        path: `/api/accreditivs/v1/external/abs/getAccreditivList`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
